<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Applicant Information</h6>
            <div class="row mb-4">
                <div class="col-lg-12 col-sm-12">
                    <form-input placeholder="Last Name" label="Last Name" v-model="form.lastname" ref="lastname"></form-input>
                </div>
                <div class="col-lg-7 col-sm-12">
                    <form-input placeholder="First Name" label="First Name" v-model="form.firstname" ref="firstname"></form-input>
                </div>
                <div class="col-lg-5 col-sm-12">
                    <form-input placeholder="Middle Name" label="Middle Name" v-model="form.middlename" ref="middlename" show-optional-label optional-label="(Optional)"></form-input>
                </div>
                <div class="col-sm-12 pb-4">
                    <checkbox class="inline-block" v-model="form.is_owner"></checkbox>
                    <div class="inline-block">Are you the Shop Owner?</div>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Owner Mobile No." placeholder="13-digit mobile no" :mask="['+639#########']" v-model="form.contact_no" ref="contact_no"></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Owner Email" placeholder="Owner Email" v-model="form.email" ref="email"></form-input>
                </div>
                <div class="col-sm-12">
                    <form-input label="Referred by" placeholder="Referred by" show-optional-label optional-label="(Optional)" v-model="form.referrer_name" ref="referrer_name"></form-input>
                </div>

                <div class="col-sm-12">
                    <button v-if="!isRequesting" class="btn btn-warning float-right" @click="next">
                        Next <i class="fas fa-angle-right ml-2"></i>
                    </button>
                    <button v-else class="btn btn-warning float-right" disabled>
                        <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import { validateApplicantInfo } from "../helpers";

export default {
    name: "ApplicantSection",

    computed: {
        parentFormData() {
            return this.$parent.$parent.data || {};
        },
        isOwner() {
            return this.$parent.$parent.data.is_owner;
        }
    },

    data: () => ({
        isRequesting: false,
        form: {
            firstname: "",
            middlename: "",
            lastname: "",
            is_owner: false,
            contact_no: "",
            email: "",
            referrer_name: "",
        }
    }),

    methods: {
        initialize() {
            this.isRequesting = false;
            this.form = {
                firstname: this.parentFormData.firstname || "",
                middlename: this.parentFormData.middlename || "",
                lastname: this.parentFormData.lastname || "",
                is_owner: this.parentFormData.is_owner || false,
                contact_no: this.parentFormData.contact_no || "",
                email: this.parentFormData.email || "",
                referrer_name: this.parentFormData.referrer_name || "",
            };
        },
        next() {
            this.isRequesting = true;
            validateApplicantInfo(this.form)
                .then(response => this.$emit("next", {...this.form}))
                .catch(error => {
                    console.log(error);
                    this.promptFormErrors(this.$refs, error)
                })
                .finally(() => this.isRequesting = false);
        },

    },

    mixins: [mixins],

    mounted() {
        this.initialize();
    }

}
</script>